export default __webpack_public_path__ + "static/media/ok4.1d5a6ae3.png";